import CandidatePackets from './gdpr/components/candidate_packets';
import DataProtectionOfficer from './gdpr/components/data_protection_officer';
import DiscloseOnJobPosts from './gdpr/components/disclose_on_job_posts';
import Header from './gdpr/components/header';
import Mounter from 'shared/utils/mounter';
import MultipleRules from './gdpr/components/multiple_rules';
import documentReady from 'document-ready';
import { ConsentExtensionEmail } from './gdpr/components/consent_extension_emails/consent_extension_email';
import ConsentExtensionEmailNudge from './gdpr/components/consent_extension_email_nudge';
import EmailTemplateFooter from './gdpr/components/email_template_footer';
import CandidateResponseNotice from './gdpr/components/candidate_response/notice';
import ManageMyConsent from 'gdpr/components/candidate_response/manage_my_consent';
import SinglePurposeConsentOptInCallOut from './gdpr/components/single_purpose_consent_opt_in';

const Gdpr = {
  CandidatePackets,
  DiscloseOnJobPosts,
  Header,
  MultipleRules,
  DataProtectionOfficer,
  ConsentExtensionEmail,
  ConsentExtensionEmailNudge,
  SinglePurposeConsentOptInCallOut,
  EmailTemplateFooter,
  CandidateResponseNotice,
  ManageMyConsent,
} as const;

documentReady(() => {
  new Mounter({ Gdpr }).mountAll();
});
